// Mock data for Smart Automation website
import { siteConfig } from '../config/site';

export const companyInfo = {
  name: siteConfig.companyName,
  tagline: siteConfig.companyTagline,
  description: siteConfig.companyDescription,
  address: siteConfig.companyAddress,
  phone: siteConfig.companyPhone,
  email: siteConfig.companyEmail,
  whatsapp: siteConfig.companyWhatsapp,
  branches: siteConfig.branches
};

export const stats = [
  { label: "Projects Completed", value: 250, suffix: "+" },
  { label: "Years Experience", value: 15, suffix: "+" },
  { label: "Happy Clients", value: 180, suffix: "+" },
  { label: "Team Members", value: 45, suffix: "+" }
];

export const services = [
  {
    id: 1,
    title: "Smart Home Automation",
    description: "Intelligent control systems for lighting, climate, security, and entertainment",
    icon: "Home"
  },
  {
    id: 2,
    title: "Audio visual system",
    description: "Integrated AV systems for boardrooms, auditoriums, and collaboration spaces with centralized control",
    icon: "Tv"
  },
  {
    id: 3,
    title: "Networking Infrastructure (Wi-Fi and Wired)",
    description: "Enterprise-grade wired and wireless network design, deployment, and performance optimization",
    icon: "Globe"
  },
  {
    id: 4,
    title: "Home theatre",
    description: "Custom home theatre installations with cinematic sound, display calibration, and intuitive automation",
    icon: "Monitor"
  },
  {
    id: 5,
    title: "CCTV Surveillance Systems",
    description: "Advanced IP and analog surveillance with remote monitoring capabilities",
    icon: "Camera"
  },
  {
    id: 6,
    title: "Video Door Phones",
    description: "Modern intercom and video door entry systems for homes and offices",
    icon: "Video"
  },
  {
    id: 7,
    title: "Intrusion Alarm System",
    description: "Intelligent intrusion alarm solutions with perimeter sensors, instant alerts, and 24/7 threat monitoring",
    icon: "Bell"
  },
  {
    id: 8,
    title: "Access Control Systems",
    description: "Biometric and card-based access control for enhanced security",
    icon: "Shield"
  },
  {
    id: 9,
    title: "Fire Alarm Systems\nFire Hydrant Systems",
    description: "Integrated fire alarm and fire hydrant solutions covering detection, alerting, control panels, and emergency water distribution infrastructure for complete life-safety readiness",
    icon: "Flame"
  },
  {
    id: 10,
    title: "Intercom and Fiber Network Solutions",
    description: "Reliable intercom and fiber backbone infrastructure for high-speed communication across facilities",
    icon: "Cable"
  },

  {
    id: 11,
    title: "Building Management Systems",
    description: "Integrated BMS solutions for optimal building operations and efficiency",
    icon: "Building2"
  },


  {
    id: 12,
    title: "Solar rooftop",
    description: "End-to-end rooftop solar systems with generation monitoring, protection, and electrical integration",
    icon: "Sun"
  },


];

export const whyChooseUs = [
  {
    title: "Certified Engineers",
    description: "Our team consists of certified professionals with extensive industry experience and technical expertise."
  },
  {
    title: "High Quality Equipment",
    description: "We use only premium, internationally certified equipment from leading manufacturers for reliability."
  },
  {
    title: "Customized Solutions",
    description: "Every project is tailored to meet your specific requirements, budget, and future scalability needs."
  },
  {
    title: "24/7 Technical Support",
    description: "Round-the-clock technical support and maintenance services to ensure your systems run smoothly."
  },
  {
    title: "On-Time Project Delivery",
    description: "We pride ourselves on completing projects within agreed timelines without compromising quality."
  }
];

export const projectCategories = [
  {
    slug: "home-automation",
    title: "Home Automation",
    description: "Integrated smart living environments with lighting, climate, security, and entertainment control.",
    image: "/images/jeetmanyu.png",
    heroVideo: "/videos/home-automation-showcase.mp4",
    heroPoster: "/images/shridhar-alayam.jpg",
    eyebrow: "Residential Intelligence",
    summary: "From villas to premium apartments, our home automation environments unify comfort, security, and control into one reliable infrastructure layer.",
    overview: "This category covers intelligent living environments where lighting, HVAC, security, entertainment, and access systems are brought under one seamless control experience.",
    capabilities: ["Lighting and scene automation", "Climate and comfort control", "Security integration", "Entertainment and AV control"]
  },
  {
    slug: "residential",
    title: "Residential",
    description: "High-comfort residential systems designed for apartments, villas, and premium housing developments.",
    image: "https://images.unsplash.com/photo-1751945965597-71171ec7a458?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxzbWFydCUyMGhvbWUlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzE1ODI1NTl8MA&ixlib=rb-4.1.0&q=85",
    heroEmbed: "https://www.youtube.com/embed/RE5i1Xgr1Jw?autoplay=1&mute=1&controls=0&loop=1&playlist=RE5i1Xgr1Jw&playsinline=1&rel=0&modestbranding=1&start=61",
    eyebrow: "Residential Delivery",
    summary: "Structured low-voltage systems for township communities, apartments, and premium residences with a focus on safety, access, and modern convenience.",
    overview: "This category focuses on apartment clusters, premium residential developments, and mixed-use housing environments where automation and low-voltage systems need to improve safety, convenience, connectivity, and day-to-day control for residents and facility teams.",
    capabilities: ["CCTV and common-area surveillance", "Video door phone and visitor access", "Wi-Fi backbone and network distribution", "Lighting automation for common zones"]
  },
  {
    slug: "corporate",
    title: "Corporate",
    description: "Enterprise-grade automation, AV, and low-voltage deployment for offices and business campuses.",
    image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1600&q=80",
    heroVideo: "/videos/corporate_video.mp4",
    heroPoster: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1600&q=80",
    eyebrow: "Enterprise Infrastructure",
    summary: "Boardrooms, business parks, and corporate floors built around clean AV, control systems, and dependable network backbones.",
    overview: "This category is built around office and enterprise spaces where presentation technology, collaboration systems, security, and connectivity all have to work together without friction.",
    capabilities: ["Boardroom AV systems", "Meeting room automation", "Enterprise networking", "Integrated access and surveillance"]
  },
  {
    slug: "manufacturing-industry",
    title: "Manufacturing Industry",
    description: "Reliable infrastructure for manufacturing plants, production sites, and industrial facilities.",
    image: "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?auto=format&fit=crop&w=1600&q=80",
    heroVideo: "/videos/manufacturing.mp4",
    heroPoster: "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?auto=format&fit=crop&w=1600&q=80",
    eyebrow: "Manufacturing Reliability",
    summary: "Monitoring, alarms, access, and network infrastructure designed for uptime across plants, warehouses, and heavy-duty production facilities.",
    overview: "This category addresses operational manufacturing environments where plant surveillance, industrial communication, safety systems, and access visibility must perform continuously across production floors, dispatch zones, and support facilities.",
    capabilities: ["Plant surveillance coverage", "Intrusion and fire detection", "Industrial communication backbone", "Controlled access across production zones"]
  },
  {
    slug: "educational-institution",
    title: "Educational Institution",
    description: "Scalable security, networking, and smart infrastructure for schools, campuses, and training environments.",
    image: "https://images.unsplash.com/photo-1580582932707-520aed937b7b?auto=format&fit=crop&w=1200&q=80",
    heroVideo: "/videos/edu_bg_video.mp4",
    heroPoster: "https://images.unsplash.com/photo-1580582932707-520aed937b7b?auto=format&fit=crop&w=1200&q=80",
    eyebrow: "Campus Infrastructure",
    summary: "Integrated surveillance, networking, announcement, and classroom-ready automation tailored for schools and institutional campuses.",
    overview: "This category focuses on school and campus environments where safety, communication, access visibility, classroom technology, and dependable networking all need to work together throughout daily academic operations.",
    capabilities: ["Campus-wide CCTV and monitoring", "PA, bell, and communication systems", "Classroom AV and smart support", "Student, staff, and visitor access visibility"]
  }
];

export const clientNames = [
  "Ajay Shridhar",
  "A SHRIDHAR Infracon Pvt Ltd",
  "Rushil Decor",
  "Gautam Adani House",
  "Riddhi Siddhi Gloco Bios Ltd",
  "Gateway Technolab",
  "Venetian Villas",
  "Dineshbhai Basant Bahar ",
  "Shantikrupa Estate",
  "Jagdish Bhatia",
  "Mayura Villa",
  "Manan Trivedi",
  "Vishwa Infra Groups",
  "Dr Pranjal",
  "Narendrabhai Patel",
  "Jayantibhai Rahtogi",
  "Naimishbhai Patel",
  "Parishbhai Patel",
  "Pankaj Mehta",
  "Rajeshbhai Lala",
  "Pravinbhai Patel",
  "Vinod Agrawal",
  "Kamalbhai Jambuwala",
  "Saunak Films Pvt Ltd",
  "SPIPA",
  "Rupeshbhai",
  "Surya International",
  "Yogeshbhai Bhavsar",
  "Axis Infrastructure Ltd",
  "Bajaj Foods Ltd",
  "Shashwat Bungalows",
  "Gulmohar Golf Club",
  "Mission Health",
  "Shree Ganesh Chemicals",
  "Antroli Jain Derasar",
  "Vasant Kunj Jain Darsar",
  "Palitana Visha Nima Bhavan",
  "Karmik Infrastructure",
  "Shakti Vidhyalaya",
  "Westside Cars Pvt Ltd",
  "Ghanshyambhai Patel",
  "Unique Handgloves",
  "United Transmission",
  "Anem Exports",
  "Rajesh Shah CMD Rotex Automation",
  "Dr Kamlesh Shah",
  "The Children Hospital",
  "American Steels Pvt Ltd",
  "Krystal Global Engg Ltd",
  "Rajputana Steel",
  "Civica Services",
  "Amvian Automotives Pvt Ltd",
  "Banyan Paradise Resort",
  "Nityam Square",
  "SWC Hub",
  "Shri Narayan Gurukul School",
  "Bhavin Sanghvi",
  "National Builders Pvt Ltd",
  "Tanishq Jewellers",
  "Suzlon Ltd",
  "Atlantic Villa",
  "Verona Greenwoods",
  "Gujarat Infrapipes Pvt Ltd"
];

export const projects = [
  {
    id: 1,
    title: "Shridhar Alayam",
    category: "Home Automation",
    categorySlug: "home-automation",
    image: "/images/shridhar-alayam.jpg",
    location: "Ahmedabad",
    description: "Integrated lighting, climate, curtain, and security control for a landmark private residence with centralized mobile access and premium lifestyle scenes."
  },
  {
    id: 2,
    title: "Kaveri Soham Vivanta",
    category: "Residential",
    categorySlug: "residential",
    image: "/images/kaveri_soham_vivanta.png",
    location: "Shilaj, Ahmedabad",
    description: "Residential infrastructure for a large 3 BHK development with centralized surveillance, visitor management, common-area networking, and building-wide low-voltage readiness aligned with the project's modern amenity-led positioning."
  },
  {
    id: 3,
    title: "A. Shridhar Corporate House",
    category: "Corporate",
    categorySlug: "corporate",
    image: "/images/ashridhar_corporate.png",
    location: "Ahmedabad",
    description: "Corporate AV, automation, surveillance, and networking delivery for A. Shridhar Corporate House near Kaveri Sangam, Shilaj, Ahmedabad, supporting a polished enterprise workspace environment."
  },
  {
    id: 5,
    title: "Krystal Steel & Engineering Co.",
    category: "Manufacturing Industry",
    categorySlug: "manufacturing-industry",
    image: "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?auto=format&fit=crop&w=1200&q=80",
    video: "/videos/krystal.mp4",
    videoPoster: "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?auto=format&fit=crop&w=1200&q=80",
    location: "India",
    description: "Industrial surveillance, monitoring, and communication support aligned with a steel and engineering production environment handling pipes, fittings, flanges, and fabrication-oriented workflows."
  },
  {
    id: 7,
    title: "Jeetmanyu",
    category: "Home Automation",
    categorySlug: "home-automation",
    image: "/images/jeetmanyu.png",
    location: "Baroda",
    description: "Scene-based lighting, audio, and access automation for a premium home environment with unified digital control and seamless user experience."
  },
  {
    id: 8,
    title: "A. Shridhar Athens",
    category: "Residential",
    categorySlug: "residential",
    image: "/images/athens.png",
    location: "Ahmedabad",
    description: "Integrated low-voltage scope covering surveillance, access management, internal networking, and controlled infrastructure zones, presented here as part of our completed site experience for the client-specified Athens project."
  },
  {
    id: 9,
    title: "Viviaana Powertech",
    category: "Corporate",
    categorySlug: "corporate",
    image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1200&q=80",
    video: "/videos/corporate_conference.mp4",
    videoPoster: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1200&q=80",
    location: "Baroda",
    description: "Conference-room AV integration and presentation automation for the Viviaana Powertech office environment in Baroda, focused on clean meeting-room control and business-ready collaboration."
  },
  {
    id: 10,
    title: "Maruti Bitumen Pvt Ltd",
    category: "Manufacturing Industry",
    categorySlug: "manufacturing-industry",
    image: "https://images.jdmagicbox.com/quickquotes/images_main/epoxy-floorings-386851405-8oej3.jpg",
    location: "Chhatral, Ahmedabad",
    description: "Infrastructure monitoring and low-voltage support suited to a bitumen and construction-chemicals manufacturing environment serving road, infrastructure, and industrial project supply chains."
  },
  {
    id: 11,
    title: "Elecon Engineering",
    category: "Manufacturing Industry",
    categorySlug: "manufacturing-industry",
    image: "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?auto=format&fit=crop&w=1200&q=80",
    video: "/videos/Realistic_Fire_Hydrant_System_Video.mp4",
    videoPoster: "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?auto=format&fit=crop&w=1200&q=80",
    location: "Vallabh Vidyanagar, Anand",
    description: "Fire hydrant system deployment and life-safety support aligned with Elecon Engineering's large-scale industrial environment in Vallabh Vidyanagar, Anand, where manufacturing operations demand dependable emergency water distribution, hydrant coverage, and plant-level fire response readiness."
  },
  {
    id: 12,
    title: "DVP School",
    category: "Educational Institution",
    categorySlug: "educational-institution",
    image: "https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&w=1200&q=80",
    location: "Kasindra",
    description: "Integrated educational infrastructure covering campus surveillance, structured networking, internal communication, and classroom support for a school environment that needs daily operational reliability."
  },
  {
    id: 13,
    title: "Thamna English School",
    category: "Educational Institution",
    categorySlug: "educational-institution",
    image: "https://images.unsplash.com/photo-1497486751825-1233686d5d80?auto=format&fit=crop&w=1200&q=80",
    video: "/videos/school_video.mp4",
    videoPoster: "https://images.unsplash.com/photo-1497486751825-1233686d5d80?auto=format&fit=crop&w=1200&q=80",
    location: "Anand",
    description: "School-wide monitoring, access visibility, classroom technology support, and network infrastructure delivered for an active academic campus in Ahmedabad."
  }
];

export const technologies = [
  { name: "KNX", description: "Industry-standard building automation" },
  { name: "Zigbee", description: "Wireless smart home protocol" },
  { name: "Z-Wave", description: "Reliable home automation mesh network" },
  { name: "IP Based Systems", description: "Network-based control and monitoring" },
  { name: "IoT Integration", description: "Internet of Things connectivity" },
  { name: "BMS Systems", description: "Building Management Systems" }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Patel",
    role: "Homeowner",
    project: "Residential Villa Automation",
    text: "The smart home automation system has completely transformed how we live. Everything is so convenient and energy-efficient now. Highly professional team!",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Sharma",
    role: "Property Manager",
    project: "Commercial Complex",
    text: "Excellent work on our office building automation. The access control and CCTV integration is seamless. Their support team is very responsive.",
    rating: 5
  },
  {
    id: 3,
    name: "Amit Desai",
    role: "Business Owner",
    project: "Retail Store",
    text: "Professional installation of our security and lighting systems. The project was completed on time and within budget. Would definitely recommend!",
    rating: 5
  }
];

export const socialLinks = {
  ...siteConfig.socialLinks
};
